'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getStyles(props, context) {
    var style = props.style,
        noPadding = props.noPadding,
        flexLayout = props.flexLayout,
        flex = props.flex;


    var styles = {
        padding: noPadding ? 0 : context.muiTheme.baseTheme.spacing.desktopGutter
    };

    if (flexLayout) {
        styles.display = 'flex';
        styles.flexDirection = flexLayout;
        styles.alignItems = 'baseline';
    }

    if (flex) {
        styles.flex = flex;
    }
    return Object.assign(styles, style);
}

/**
 * @desc
 * Default styles:
 * ```
 * {
 *   padding: context.muiTheme.baseTheme.spacing.desktopGutter
 * }
 * ```
 */

var LayoutContainer = function (_React$Component) {
    _inherits(LayoutContainer, _React$Component);

    function LayoutContainer() {
        _classCallCheck(this, LayoutContainer);

        return _possibleConstructorReturn(this, (LayoutContainer.__proto__ || Object.getPrototypeOf(LayoutContainer)).apply(this, arguments));
    }

    _createClass(LayoutContainer, [{
        key: 'render',


        /**
         * @return {Node}
         */

        /**
         * @type {Object}
         * @property {Node} children child nodes
         * @property {string} id DOM id
         * @property {string} className DOM class
         * @property {Object} style inline styles
         * @property {boolean} noPadding remove padding
         * @property {string} flexLayout type of layout [row|column|row-reverse|column-reverse]
         * @property {string} flex css flex string
         */
        value: function render() {
            var styles = getStyles(this.props, this.context);
            var classes = [];
            if (this.props.flexLayout) {
                classes.push(this.props.flexLayout);
            }
            if (this.props.className) {
                classes.push(this.props.className);
            }
            return _react2.default.createElement(
                'div',
                { id: this.props.id, className: classes.join(' '), style: styles },
                this.props.children
            );
        }

        /**
         * @type {Object}
         * @property {Object} muiTheme theme
         */

    }]);

    return LayoutContainer;
}(_react2.default.Component);

LayoutContainer.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    id: _propTypes2.default.string,
    style: _propTypes2.default.object,
    noPadding: _propTypes2.default.bool,
    flexLayout: _propTypes2.default.string,
    flex: _propTypes2.default.string
};
LayoutContainer.contextTypes = {
    muiTheme: _propTypes2.default.object.isRequired
};
exports.default = LayoutContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/material/LayoutContainer.js
// module id = 1002
// module chunks = 0